import request from '@/utils/request'

// 查询用户最近上传的文件
export function getUserRecentlyUploadFile(query) {
  return request({
    url: process.env.PICTURE_API + '/file/getUserRecentlyUploadFile',
    method: 'post',
    data: query
  });
}

/**
 * 上传前置校验
 * @param query
 * @returns {*}
 */
export function getFileByMD5(query) {
  return request({
    url: process.env.PICTURE_API + '/file/getFileByMD5',
    method: 'post',
    data: query
  });
}






// WEBPACK FOOTER //
// ./src/api/file.js